var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"common-form mt50"},[_vm._v("商品详情")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"内容："}},[_c('div',{staticClass:"edit_container"},[_c('Uediter',{ref:"ue",attrs:{"text":_vm.form.model.content,"config":_vm.ueditor.config},on:{"contentChange":_vm.contentChangeFunc}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b131e9d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/product/product/part/Content.vue
// module id = null
// module chunks = 